// URLs de los webhooks reales
const REGISTRO_WEBHOOK = 'https://automatizacion.commerk.com:4444/webhook/a5c6404f-5410-4895-8a41-03cab1aaba2f';
const RESPUESTAS_WEBHOOK = 'https://automatizacion.commerk.com:4444/webhook/1403562f-b86e-4f5f-8e33-9ef5c0e1e3b8';

// Flag para controlar si usamos datos reales o de prueba
const USE_REAL_DATA = true; // Cambia esto a false para usar siempre datos de prueba

// Función para registrar al usuario y obtener preguntas
export const registerUser = async (userData) => {
  // Si no usamos datos reales, devolvemos directamente los datos de prueba
  if (!USE_REAL_DATA) {
    console.log('🔸 USANDO DATOS DE PRUEBA: No se está llamando al webhook de registro');
    return getMockQuestions();
  }

  try {
    // Formateamos los datos según el formato requerido por el webhook
    const requestData = {
      pregunta: "muestrame las preguntas",
      nombre: userData.name,
      telefono: parseInt(userData.phone.replace(/\D/g, '')), // Convertimos a número y quitamos caracteres no numéricos
      correo: userData.email,
      tratamiento: userData.dataConsent,
      edad: userData.ageRange
    };

    console.log('🔹 LLAMANDO AL WEBHOOK DE REGISTRO');
    console.log('📤 Datos enviados:', JSON.stringify(requestData, null, 2));

    const response = await fetch(REGISTRO_WEBHOOK, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(requestData),
    });

    const responseStatus = response.status;
    console.log(`📥 Respuesta del servidor: Estado ${responseStatus}`);

    // Obtenemos los datos de la respuesta
    const data = await response.json();
    console.log('📥 Datos recibidos del webhook:', JSON.stringify(data, null, 2));
    
    // Verificamos si hay un mensaje de error específico de usuario ya registrado
    if (data.statusCode === 404 && data.error && data.error.includes("ya se encuentra registrado")) {
      console.log('⚠️ Usuario ya registrado:', data.error);
      // Devolvemos el objeto de error completo para que pueda ser manejado en el contexto
      return {
        statusCode: 404,
        error: data.error
      };
    }
    
    // Si la respuesta no es exitosa y no es un error de usuario ya registrado
    if (!response.ok) {
      throw new Error(`Error en la respuesta: ${response.status}`);
    }

    // Verificamos si tenemos preguntas en la respuesta
    if (data.preguntas && data.preguntas.length > 0) {
      console.log(`✅ Se recibieron ${data.preguntas.length} preguntas del webhook`);
      return data.preguntas || [];
    } else {
      console.warn('⚠️ El webhook no devolvió preguntas o devolvió un array vacío');
      console.log('🔸 Usando datos de prueba como fallback');
      return getMockQuestions();
    }
  } catch (error) {
    console.error('❌ Error al registrar usuario:', error);
    console.log('🔸 Usando datos de prueba como fallback debido al error');
    
    // Si es un error de red o del servidor, verificamos si contiene datos de respuesta
    if (error.response && error.response.data) {
      // Si el error contiene datos que indican que el usuario ya está registrado
      if (error.response.data.statusCode === 404 && 
          error.response.data.error && 
          error.response.data.error.includes("ya se encuentra registrado")) {
        return {
          statusCode: 404,
          error: error.response.data.error
        };
      }
    }
    
    // Para otros errores, usamos los datos de prueba
    return getMockQuestions();
  }
};

// Función para enviar las respuestas del quiz y obtener los resultados
export const sendAnswers = async (userData, answers) => {
  // Si no usamos datos reales, devolvemos directamente los datos de prueba
  if (!USE_REAL_DATA) {
    console.log('🔸 USANDO DATOS DE PRUEBA: No se está llamando al webhook de respuestas');
    return getMockResult(answers);
  }

  try {
    // Obtenemos el ID del usuario (teléfono)
    const userId = parseInt(userData.phone.replace(/\D/g, ''));
    
    // Formateamos las respuestas según el formato requerido
    const formattedAnswers = answers.map(answer => {
      return {
        [answer.questionId]: {
          titulo: answer.questionTitle,
          respuestas: answer.answerText
        }
      };
    });

    const requestData = {
      id: userId,
      type: "json",
      body: formattedAnswers
    };

    console.log('🔹 LLAMANDO AL WEBHOOK DE RESPUESTAS');
    console.log('📤 Datos enviados:', JSON.stringify(requestData, null, 2));

    const response = await fetch(RESPUESTAS_WEBHOOK, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(requestData),
    });

    const responseStatus = response.status;
    console.log(`📥 Respuesta del servidor: Estado ${responseStatus}`);

    if (!response.ok) {
      throw new Error(`Error en la respuesta: ${response.status}`);
    }

    // La respuesta del API contiene el resultado del quiz
    const data = await response.json();
    console.log('📥 Datos recibidos del webhook:', JSON.stringify(data, null, 2));
    
    // Verificamos si tenemos un resultado válido
    if (data && Object.keys(data).length > 0) {
      console.log('✅ Se recibió un resultado válido del webhook');
      return data;
    } else {
      console.warn('⚠️ El webhook devolvió datos vacíos o inválidos');
      console.log('🔸 Usando resultado de prueba como fallback');
      return getMockResult(answers);
    }
  } catch (error) {
    console.error('❌ Error al enviar respuestas:', error);
    console.log('🔸 Usando resultado de prueba como fallback debido al error');
    return getMockResult(answers);
  }
};

// Función para simular la obtención de preguntas (para desarrollo)
export const getMockQuestions = () => {
  console.log('📝 Generando preguntas de prueba');
  return [
    {
      id: "pregunta1",
      titulo_pregunta: "¿Cómo describirías tu estilo de vida?",
      respuestas_preguntas: [
        { respuesta: "Siempre buscando diversión y fiestas; vivo el momento", categoria: "Alma de la Fiesta", codigo: "alma_fiesta" },
        { respuesta: "Clásico, con carácter y sabor auténtico", categoria: "Clásico Auténtico", codigo: "clasico" },
        { respuesta: "Siempre buscando nuevas experiencias y aventuras", categoria: "Explorador", codigo: "explorador" }
      ]
    },
    {
      id: "pregunta2",
      titulo_pregunta: "¿Qué prefieres en una reunión social?",
      respuestas_preguntas: [
        { respuesta: "Un bar con música alta y buena onda", categoria: "Alma de la Fiesta", codigo: "alma_fiesta" },
        { respuesta: "Un lugar tranquilo con amigos cercanos", categoria: "Sofisticado", codigo: "sofisticado" },
        { respuesta: "Una playa o espacio al aire libre con cócteles", categoria: "Relajado", codigo: "relajado" }
      ]
    },
    {
      id: "pregunta3",
      titulo_pregunta: "¿Qué tipo de sabor prefieres en tu bebida?",
      respuestas_preguntas: [
        { respuesta: "Dulce y fácil de tomar", categoria: "Explorador", codigo: "explorador" },
        { respuesta: "Amarga y compleja", categoria: "Connoisseur", codigo: "connoisseur" },
        { respuesta: "Equilibrada y suave", categoria: "Sofisticado", codigo: "sofisticado" }
      ]
    },
    {
      id: "pregunta4",
      titulo_pregunta: "¿Qué frase te representa?",
      respuestas_preguntas: [
        { respuesta: "¡La vida es una sola!", categoria: "Alma de la Fiesta", codigo: "alma_fiesta" },
        { respuesta: "Lo bueno se toma con calma", categoria: "Clásico Auténtico", codigo: "clasico" },
        { respuesta: "Me gusta experimentar", categoria: "Explorador", codigo: "explorador" }
      ]
    },
    {
      id: "pregunta5",
      titulo_pregunta: "¿Cómo eliges a tus amigos?",
      respuestas_preguntas: [
        { respuesta: "Entre más, mejor", categoria: "Alma de la Fiesta", codigo: "alma_fiesta" },
        { respuesta: "Pocos, pero de confianza", categoria: "Sofisticado", codigo: "sofisticado" },
        { respuesta: "Gente que me lleve a nuevas experiencias", categoria: "Explorador", codigo: "explorador" }
      ]
    }
  ];
};

// Función para simular la obtención de resultados (para desarrollo)
export const getMockResult = (answers) => {
  console.log('📝 Generando resultado de prueba basado en las respuestas:', answers);
  
  // Aquí podríamos hacer un cálculo simple basado en las respuestas
  // para simular el resultado del quiz
  
  // Por ahora, simplemente devolvemos un resultado fijo
  return {
    "Tipo de licor": "Ron Gran Reserva",
    "Descripción": "Vos sos un parchado que disfruta de historia, calidad y exclusividad, ¡como un buen Ron Gran Reserva! Tiene ese toque clásico, con carácter y tradición, pero también es para los que buscan algo que te reconforte y te lleve en un viaje por lo auténtico. Es un 80% de vos, parce.",
    "código": "gran_reserva",
    "Coctel sugerido": "Para preparar un cóctel fácil que te encante, mezcla 2 onzas de Ron Gran Reserva con hielo, añade una rodaja de limón y unas gotas de cola o gaseosa. Sirve en un vaso largo, con hielo y una rodaja de limón para decorar. Listo, a disfrutar con parcero, ¡salud!"
  };
};